import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const PRODUCT_QUERY = gql`
  query productQuery($input: ProductPricingInput!) {
    product(input: $input) {
      uuid
      service
      name
      description
      pricing {
        uuid
        amount
        interval
        coupon {
          uuid
          amount
          externalCouponId
        }
      }
      affiliatePricingUuid
      createdAt
      updatedAt
    }
  }
`;

export function useProduct({ affiliate, services }) {
  const { data, loading, error } = useQuery(PRODUCT_QUERY, {
    noThrow: true,
    skip: !services?.length,
    variables: {
      input: {
        affiliate,
        services
      }
    }
  });

  useError(error);

  return {
    product: data?.product,
    loading,
    hasError: Boolean(error),
    error
  };
}
